export const transformSizeForDisplay = (size: number) => {
  return String((size / 1000000).toFixed(2)) + ' MB'
}
